import { useLocation } from "react-router-dom";
import { Carousel } from "react-carousel-minimal";
import SolidButton from "./../../components/SolidButton/SolidButton";
import BorderButton from "./../../components/BorderButton/BorderButton";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const slideNumberStyle = {
  fontSize: "20px",
  fontWeight: "bold",
};

const ProjectDetail = () => {
  const { state } = useLocation();

  const images = state?.project?.images;

  const {
    title,
    description,
    client,
    server,
    liveSite,
    bulletPoints,
    technologies,
  } = state?.project;

  return (
    <div className="min-h-screen max-w-screen-xl mx-auto  mt-4  px-4">
      <h1 className="text-4xl text-center text-white font-semibold mt-9 py-4 bg-black bg-opacity-20 rounded-lg">
        {title}
      </h1>
      <div>
        <Carousel
          data={images}
          time={5000}
          width="850px"
          height="480px"
          // captionStyle={captionStyle}
          radius="10px"
          slideNumber={true}
          slideNumberStyle={slideNumberStyle}
          captionPosition="bottom"
          automatic={true}
          dots={false}
          pauseIconColor="white"
          pauseIconSize="40px"
          slideBackgroundColor="darkgrey"
          slideImageFit="cover"
          thumbnails={true}
          thumbnailWidth="100px"
          style={{
            textAlign: "center",
            maxWidth: "850px",
            maxHeight: "500px",
            margin: "40px auto",
          }}
        />
      </div>
      <div className="flex gap-2 max-w-[850px] mx-auto mt-24 bg-black bg-opacity-20 p-4 rounded-lg">
        <SolidButton
          href={liveSite}
          className="text-sm font-medium mr-auto"
          target="_blank"
          rel="noreferrer"
        >
          Live Site
        </SolidButton>
        <BorderButton
          href={client}
          className="text-sm text-cyan-500 font-medium"
          target="_blank"
          rel="noreferrer"
        >
          Client Repo
        </BorderButton>
        <BorderButton
          href={server}
          className="text-sm text-cyan-500 font-medium"
          target="_blank"
          rel="noreferrer"
        >
          Server Repo
        </BorderButton>
      </div>

      <div className="max-w-[850px] mx-auto  text-cyan-500 text-xs mt-6  bg-black bg-opacity-20 p-4 rounded-lg  font-semibold">
        <h2 className="text-xl mb-3 text-cyan-500 font-semibold ">
          Technologies:{" "}
        </h2>
        <div className="flex gap-2 flex-wrap">
          {technologies.map((tch, i) => (
            <span key={i} className="border border-cyan-500 rounded-lg px-2">
              {tch}
            </span>
          ))}
        </div>
      </div>
      <div className="max-w-[850px] mx-auto text-white text-sm md:text-base mt-6 bg-black bg-opacity-20 p-4 rounded-lg">
        <h2 className="text-xl mb-3 text-cyan-500 font-semibold ">
          Project Detail:
        </h2>
        <div className="text-xs md:text-base">{description}</div>
        <div>
          <ul className="py-2 px-4">
            {bulletPoints.map((bp, i) => (
              <li
                key={i}
                className="grid grid-cols-[16px,1fr] gap-2 items-start mb-2"
              >
                <CheckCircleIcon className="w-4 h-4 md:mt-1 text-cyan-500" />
                <span className="text-xs md:text-base ">{bp}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
